module.exports = __webpack_public_path__ + "img/ic_mus_pm.71334062.png";